define("shared/modifiers/css-properties", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.setCssProperties = setCssProperties;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f
  /**
   * Applies CSS properties to an HTMLElement based on the provided record of CSS properties.
   *
   * Example usage:
   *
   * ```hbs
   * <div ... {{css-properties (hash color="red" fontSize="16px" --my-custom-property=12)}}></div>
   *
   * @param element HTMLElement to apply CSS properties to
   * @param param1 Record of CSS properties to apply, where keys are CSS property names and values are their corresponding values
   * @returns Cleanup function to remove the applied CSS properties
   */
  function setCssProperties(element, _ref) {
    let [cssProperties] = _ref;
    const appliedProperties = new Set();
    if (cssProperties !== undefined && cssProperties !== null) {
      Object.entries(cssProperties).forEach(_ref2 => {
        let [property, value] = _ref2;
        if (value !== undefined && value !== null) {
          element.style.setProperty(property, value.toString());
          appliedProperties.add(property);
        }
      });
    }
    return () => {
      appliedProperties.forEach(property => {
        element.style.removeProperty(property);
      });
    };
  }
  const cssPropertiesModifier = (0, _emberModifier.modifier)(setCssProperties, {
    eager: false
  });
  var _default = _exports.default = cssPropertiesModifier;
});